import _ from 'lodash'
import {fetch, post, put, remove} from '@/base-http'
import CalendarEvent from '@/modules/calendar/model/CalendarEvent'
import CalendarEventType from '@/modules/calendar/model/CalendarEventType';

export interface ListEventsFilters {
    /**
     * Filtro por mes
     *
     * Este filtro permite obtener todos los eventos que ocurren en un determinado mes,
     * el formato es MM-YYYY
     */
    month?: string
}


/**
 * Obtiene una lista de eventos en función de los filtros argumentados
 *
 * @param filters
 */
export async function listEvents (filters: ListEventsFilters = {}) {
    try {
        const data = await fetch('/calendar/events', {
            params: filters,
        })

        if (!Array.isArray(data)) {
            throw new Error('Se esperaba un array con la lista de eventos')
        }

        return data.map(e => CalendarEvent.deserialize(e))
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}

/**
 * Registra un nuevo evento de calendario
 *
 * @param event
 */
export async function createCalendarEvent (event: CalendarEvent) {
    try {
        const data = await post('/calendar/event', event.serialize())

        return CalendarEvent.deserialize(data)
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}

/**
 * Registra un nuevo evento de calendario
 *
 * @param event
 */
export async function updateCalendarEvent (event: CalendarEvent) {
    try {
        const data = await put(`/calendar/events/${event.id}`, event.serialize())

        return CalendarEvent.deserialize(data)
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}


/**
 * Obtiene la lista de tipos de eventos de calendario
 */
export async function getCalendarEventTypeList () {
    try {
        const data = await fetch('/calendar/event-types')

        if (!Array.isArray(data)) {
            throw new Error('Se esperaba un array con la lista de tipos eventos')
        }

        return data.map(et => CalendarEventType.deserialize(et))
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}

/**
 * Elimina un evento de calendario
 *
 * @param event
 * @return number El id del evento eliminado
 */
export async function deleteCalendarEvent (event: CalendarEvent) {
    try {
        const data = await remove(`/calendar/events/${event.id}`)

        return data.deleted_id as number
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}

/**
 * Crea un nuevo tipo de evento de calendario
 *
 * @param type
 */
export async function createCalendarEventType (type: CalendarEventType) {
    try {
        const data = await post('/calendar/event-type', type.serialize())

        return CalendarEventType.deserialize(data)
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}

/**
 * Actualiza un tipo de evento de calendario existente en el servidor
 *
 * @param type
 */
export async function updateCalendarEventType (type: CalendarEventType) {
    try {
        const data = await put(`/calendar/event-type/${type.id}`, type.serialize())

        return CalendarEventType.deserialize(data)
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}

/**
 * Elimina un tipo de evento de calendario
 *
 * @param type
 */
export async function deleteCalendarEventType (type: CalendarEventType) {
    if (type.isNew) {
        throw new Error('No se puede eliminar un tipo de evento de calendario que aún no ha sido registrado')
    }

    try {
        const data = await remove(`/calendar/event-type/${type.id}`)

        return data.success
    } catch (e) {
        throw new Error(_.get(e, 'response.data.message', e.message))
    }
}
